import $ from 'jquery';
// import { gsap } from 'gsap';
import Parallax from 'parallax-js';

import { $Elements, Animations, BrowserEvents, Classes } from '../global/constants';

// ---------- Init Base Animation ----------

export const initBaseAnimations = () => {

	// ---------- Animations ----------

	// ---------- Mouse Parallax ----------

	$('.hero-header-section').each(function() {
		Animations.global.push(() => {
			const parallax = new Parallax(this.querySelector('.parallax-column .content'), {
				pointerEvents: true,
			});
		});
	});
};

$Elements.document.on(BrowserEvents.page.enter, () => initBaseAnimations());
